import { Box, BoxProps, Stack, StackProps } from "@mui/material";

type TabSubSectionProps = {
  /** @deprecated Handled by `gap` */
  first?: boolean;
} & BoxProps;

export const TabSubSection = ({ children, ...props }: TabSubSectionProps) => (
  <Box p={3} bgcolor="primary.25" {...props}>
    {children}
  </Box>
);

type TabSectionProps = { first?: boolean } & StackProps;

const TabSection = ({ first, children, ...props }: TabSectionProps) => (
  <Stack
    gap={0.5}
    mt={first ? undefined : 3}
    borderRadius={2}
    overflow="hidden"
    {...props}
  >
    {children}
  </Stack>
);

export default TabSection;
